import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$tipos_pdv = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      tipoPdvAddOrEdit: "new",
      text: "",
      loading: false,
      tipos_pdv: [],
      cadastro: {
        loading: false,
        idtipopdv: "",
        descricao: "",
        ativo: "",
        error: {
          descricao: [],
          ativo: [],
        },
      },
      filtros: [],
      filter: {
        descricao: "",
        status: "",
        dataInicio: "",
        dataFim: "",
      },
    };
  },
  methods: {
    /**
     * @description Método para listar tipos de ponto de venda
     */
    getTiposPDV() {
      this.loading = true;
      this.$axios.post(this.ENDPOINTS.LISTAR_TIPO_PDV).then(response => {
        if (response) {
          this.$axios.setLocal("tipos-pdv", response);
          this.tipos_pdv = response;
          this.loading = false;
        }
      });
    },

    /**
     * @description Método para alterar tipo de ponto de venda
     */
    alterarTipoPDV() {
      let dados = {
        descricao: this.cadastro.descricao,
        ativo: this.cadastro.ativo,
      };

      this.$axios
        .put(this.ENDPOINTS.ALTERAR_TIPO_PDV + this.cadastro.idtipopdv, dados)
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditTipoPDV", true);
            document.getElementsByClassName(
              "modal-body-tipo-pdv-add"
            )[0].style.display = "none";
            (this.cadastro.descricao = ""),
              (this.cadastro.ativo = ""),
              this.getTiposPDV();
          }
        });
    },

    /**
     * @description Método para cadastrar tipo de ponto de venda
     */
    async cadastrarTipoPDV() {
      this.loading = true;
      this.cadastro.loading = true;
      let dados = {
        descricao: this.cadastro.descricao,
        ativo: this.cadastro.ativo,
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_TIPO_PDV, dados)
        .then(response => {
          if (response) {
            this.cadastro.descricao = "";
            this.cadastro.ativo = "";
            document.getElementsByClassName(
              "modal-body-tipo-pdv-add"
            )[0].style.display = "none";
            this.getTiposPDV();
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description Método para deletar tipo de ponto de venda
     * @param {String} idtipopdv - ID do tipo de ponto de venda
     */
    deletarTiposPDV(idtipopdv) {
      this.$axios
        .delete(this.ENDPOINTS.DELETAR_TIPO_PDV + idtipopdv)
        .then(() => this.getTiposPDV())
        .catch(error => {
          throw new Error(error);
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    /**
     * @description Método para abrir o modal de confirmação de remoção do tipo de ponto de venda
     * @param {id} String - ID do tipo de ponto de venda
     * @param {msg} String - Mensagem de confirmação
     */
    remover(id, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.cadastro.idtipopdv = id;
    },

    /**
     * @description Método de confirmação de remoção de tipos de ponto de venda
     */
    funcaoRemover() {
      this.loading = true;
      this.deletarTiposPDV(this.cadastro.idtipopdv);
    },

    /**
     * @description Função que filtra tipos de ponto de venda
     */
    filtroTipoPDV() {
      this.filtros = [];
      if (this.filter.descricao != "" && this.filter.descricao != null) {
        this.filtros.push({
          campo: "descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }

      if (
        (this.filter.status != "" && this.filter.status != null) ||
        this.filter.status == 0
      ) {
        this.filtros.push({
          campo: "ativo",
          tipo: "string",
          orientacao: "=",
          valor: this.filter.status,
        });
      }

      if (this.filter.dataInicio != "" && this.filter.dataInicio != null) {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: this.filter.dataInicio + " 00:00",
        });
      }

      if (this.filter.dataFim != "" && this.filter.dataFim != null) {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: this.filter.dataFim + " 23:59",
        });
      }

      let filtered = this.filtros;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_TIPO_PDV,
          JSON.stringify({ filtros: filtered })
        )
        .then(response => {
          this.tipos_pdv = response;
        });
    },

    /**
     * @description Função que valida dados de cadastro e alteração de tipos de ponto de venda
     */
    async validarCadastro() {
      if (
        this.cadastro.descricao == "" ||
        this.cadastro.descricao == undefined
      ) {
        this.$config.alert(
          "Preencha a descrição do tipo de venda!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.descricao =
          "Preencha a descrição do tipo de venda!";
        return;
      }

      if (this.cadastro.ativo == null) {
        this.$config.alert(
          "Selecione o status!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.ativo = "Selecione o status!";
        return;
      }

      if (this.tipoPdvAddOrEdit == "edit") {
        this.alterarTipoPDV();
      } else {
        this.cadastrarTipoPDV();
      }
    },

    limparFormularioDeTipoPDV() {
      this.cadastro.descricao = "";
      this.cadastro.ativo = "";
      this.cadastro.error.descricao = "";
      this.cadastro.error.ativo = "";
    },
  },
});
